
export const AUTH = {
  SET_USER: 'SET_USER',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED'
}

export const GLOBAL = {
  SET_MESSAGE: 'SET_MESSAGE',
  RESET_MESSAGE: 'RESET_MESSAGE',
  SET_LOADING: 'SET_LOADING'
}

export const CLIENT = {
  CLIENT_SET: 'CLIENT_SET',
  SET_CLIENT_ID: 'SET_CLIENT_ID'
}

export const LOCATION ={
  LOCATION_SET: 'LOCATION_SET'
}
export const SERVICE_REQUEST = {
  CURRENT_DATE_SET: 'CURRENT_DATE_SET',
  SET_LOCATION_QUERY_FILTER: 'SET_LOCATION_QUERY_FILTER',
  SET_CLIENT_FILTER: 'SET_CLIENT_FILTER',
  SET_REQUESTS: 'SET_REQUESTS',
  SET_SELECTED_REQUEST: 'SET_SELECTED_REQUEST'
}
